/**
 * Called on app start to display the unsupported browser page (or not).
 */

export const SET_BROWSER_DETAILS = 'SET_BROWSER_DETAILS';
export const IGNORE_UNSUPPORTED_BROWSER = 'IGNORE_UNSUPPORTED_BROWSER';

/**
 * Action that is dispatched to store the information we need about the web
 * browser. This is fired in init, after Bowser and Modernizr have run.
 * @param platform
 *  - a string: "desktop"/"ios"/"android".
 * @param oldVersion
 *  - a boolean: true if the browser version is known to cause problems.
 * @param missingFeature
 *  - a boolean: true if the browser is missing support for a feature we use.
 * @param supportsFetch
 *  - a boolean: true if fetch is supported by the browser
 * @param animationBroken
 *  - a boolean: true if react-velocity isn't going to work.
 * @param browserIsInternetExplorer
 *  - a boolean: true if the user is using Internet Explorer
 * @param browserDetails
 *  - a string giving details of the browser, to be used in error messages - for
 *  example "Chrome 71.0 on macOS 10.14.0"
 */
export function setBrowserDetails(spec) {
    const {
        platform,
        oldVersion,
        missingFeature,
        supportsFetch,
        animationBroken,
        browserIsInternetExplorer,
        browserDetails,
    } = spec;

    return {
        type: SET_BROWSER_DETAILS,
        platform,
        oldVersion,
        missingFeature,
        supportsFetch,
        animationBroken,
        browserIsInternetExplorer,
        browserDetails,
    };
}

export const ignoreUnsupportedBrowser = () => ({
    type: IGNORE_UNSUPPORTED_BROWSER,
});
